<template>
  <el-table-column
    :key="field.prop"
    :width="field.width"
    :sortable="field.sortable ? 'custom' : false"
    :label="field.label"
    :prop="field.prop"
    :min-width="200"
  >
    <template slot-scope="scope" class="pull-right">
      <span>
        <el-select
          :value="scope.row[field.prop]"
          filterable
          class="event-select select-input"
          @change="setEventToBilety24DateConfirm($event, scope.row)"
        >
          <el-option
            v-for="event in events"
            :key="event.id"
            :label="event.title_pl"
            :value="event.id"
          />
        </el-select>
        <router-link
          :to="{
            name: 'Add Event',
            query: {
              bilety24_event_date: scope.row.id
            }
          }"
        >
          <el-button> Utwórz nowe wydarzenie </el-button>
        </router-link>
      </span>
    </template>
  </el-table-column>
</template>

<script>
import { Bilety24EventDate } from '@/api'

export default {
  props: ['field'],
  computed: {
    events() {
      return this.$store.state.eventsToAssignBilety24
    }
  },
  methods: {
    setEventToBilety24DateConfirm(eventId, bilety24EventDate) {
      const event = this.events.find(event => event.id === eventId)

      const message = `Przypisz wydarzenie ${bilety24EventDate.title_pl} z Bilety24 do ${event.title_pl}`
      this.$confirm(message)
        .then(() => {
          this.setEventToBilety24Date(eventId, bilety24EventDate)
        })
        .catch(() => {})
    },
    setEventToBilety24Date(eventId, bilety24EventDate) {
      Bilety24EventDate.assignBilety24ToEvent(bilety24EventDate.id, eventId)
        .then(() => {
          const index = this.events.findIndex(event => event.id === eventId)
          if (index > -1) {
            this.events.splice(index, 1)
          }
          bilety24EventDate.event = eventId

          this.$message({
            message: 'Wydarzenie zostało powiązane z biletem',
            type: 'success'
          })
        })
        .catch(() => {
          this.$message({
            message: 'Wystąpił bład podczas powiązywania wydarzenia z biletem',
            type: 'error'
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.event-select {
  width: 60%;
  padding: 7px;
  border-radius: 8px;
  background-color: #eeffee47;
}
</style>
